import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { coerceHttpParams } from 'src/app/shared/flight-log-api/shared/create-request-options';
import { StatsDto } from 'src/app/shared/flight-log-api/stats/stats-client.model';
import { FLIGHT_LOG_API_CONFIG, FlightLogApiConfiguration } from '../flight-log-api-configuration';

@Injectable({ providedIn: 'root' })
export class StatsHttpClient {
  constructor(
    @Inject(FLIGHT_LOG_API_CONFIG) private config: FlightLogApiConfiguration,
    private http: HttpClient,
  ) {}

  public getFlightAndDutyTime(
    pilotEmployeeId: string,
    startTime: Date | undefined,
    endTime: Date | undefined,
  ): Observable<StatsDto> {
    const params: any = { pilotEmployeeId };
    if (startTime != null) {
      params.startTime = startTime.toISOString();
    }
    if (endTime != null) {
      params.endTime = endTime.toISOString();
    }
    return this.http.get<StatsDto>(this.url(`stats/flightAndDutyTime?`), {
      params: coerceHttpParams(params),
    });
  }

  public url(path: string) {
    return this.config.baseUri + '/api/' + path;
  }
}
